import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDownsize2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconDownsize2"><Path d="M3.5 10.5H10.5V3.5" stroke="currentColor" strokeLinecap="square"/><Path d="M20.5 10.5H13.5V3.5" stroke="currentColor" strokeLinecap="square"/><Path d="M13.5 20.5V13.5H20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 13.5H10.5V20.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconDownsize2;
